import Children from '../../../layouts/Children';

const routes = [
  {
    path: 'building-complexes-contracts',
    component: Children,

    children: [
      {
        path: '',
        name: 'building-complexes-contracts',
        component: () =>
          import(
            '@/modules/building_complexes_contracts/pages/BuildingComplexesContractsPage'
          )
      }
    ]
  }
];

export default routes;
